import { createFileRoute } from "@tanstack/react-router";
import { ServicePartnerEditor } from "@/servicePartners/ServicePartnerEditor";
import { parseServicePartnersSearch } from "@/servicePartners/servicePartnersSearch";

export const Route = createFileRoute(
  "/_authenticated/platform-management_/service-partners_/new",
)({ validateSearch: parseServicePartnersSearch, component: NewPartnerRoute });
function NewPartnerRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ServicePartnerEditor
      onBack={() => {
        void navigate({ to: "/platform-management/service-partners", search });
      }}
    />
  );
}
